import Vue from 'vue';
import api from '@/store/helpers/api';

export default {
  state: {
    redirects: [],
  },
  getters: {
    redirectIndexById: (state) => (redirectId) =>
      state.redirects.findIndex((rule) => rule.id === redirectId),
  },
  mutations: {
    SET_REDIRECTS(state, redirects) {
      state.redirects = redirects;
    },
    ADD_REDIRECT(state, redirect) {
      state.redirects.push(redirect); // this might not include all fields, like statusCode
    },
    UPDATE_REDIRECT(state, { idxToUpdate, rule }) {
      Vue.set(state.redirects, idxToUpdate, {
        ...state.redirects[idxToUpdate],
        ...rule,
      });
    },
    REMOVE_REDIRECT(state, idxToRemove) {
      state.redirects.splice(idxToRemove, 1);
    },
  },
  actions: {
    loadRedirects({ commit }) {
      commit('SET_LOADING_STATE', true);

      return new Promise((resolve, reject) => {
        api
          .get('redirects')
          .then((response) => {
            const redirects = response.data;
            commit('SET_REDIRECTS', redirects);
          })
          .then(resolve)
          .catch(reject)
          .finally(() => commit('SET_LOADING_STATE', false));
      });
    },
    addRedirect({ commit }, rule) {
      return new Promise((resolve, reject) => {
        api
          .post('redirects', rule)
          .then((response) => {
            const { id } = response.data;
            commit('ADD_REDIRECT', { ...rule, id });
          })
          .then(resolve)
          .catch(reject);
      });
    },
    updateRedirect({ commit, getters }, { id, ...rule }) {
      return new Promise((resolve, reject) => {
        api
          .patch(`redirects/${id}`, rule)
          .then(() => {
            const idxToUpdate = getters.redirectIndexById(id);
            commit('UPDATE_REDIRECT', { idxToUpdate, rule });
          })
          .then(resolve)
          .catch(reject);
      });
    },
    removeRedirect({ commit, getters }, { id }) {
      return new Promise((resolve, reject) => {
        api
          .delete(`redirects/${id}`)
          .then(() => {
            const idxToRemove = getters.redirectIndexById(id);
            commit('REMOVE_REDIRECT', idxToRemove);
          })
          .then(resolve)
          .catch(reject);
      });
    },
  },
};
